import { useCallback, useEffect, useRef } from 'react';
import type { AppStateStatus } from 'react-native';
import { AppState } from 'react-native';

const ACTIVE_STATE = 'active';
const STATE_REGEX = new RegExp(/inactive|background/);

export type AppStateCallbacks = {
  onForeground?: () => void;
  onBackground?: () => void;
};

export const useAppStateEffect = (callbacks?: AppStateCallbacks) => {
  const { onForeground, onBackground } = callbacks || {};

  const appState = useRef(AppState.currentState);

  const handleAppStateChange = useCallback(
    (nextAppState: AppStateStatus) => {
      if (STATE_REGEX.test(appState.current) && nextAppState === ACTIVE_STATE) {
        console.info(
          '[USE_APP_STATE_EFFECT]: Application returns from the background'
        );
        onForeground?.();
      } else {
        console.info(
          '[USE_APP_STATE_EFFECT]: Application will be set to background'
        );
        onBackground?.();
      }

      appState.current = nextAppState;
    },
    [appState, onBackground, onForeground]
  );

  useEffect(() => {
    const subscription = AppState.addEventListener(
      'change',
      handleAppStateChange
    );

    return () => subscription.remove();
  }, [handleAppStateChange]);
};
